module.exports = __webpack_public_path__ + "static/media/gflogo.c08916a9.png";